import { MutableRecordStore, RecordStore } from '@deqo/foundation';
import { telemetry } from '../../@vendor/Posthog';
import { waitFor } from '../../CodesThatsGottaGoSomewhereElse';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';

export interface SetupProps {
    name: string;
    invites: string[];
    surveyId?: string;
}

export class SetupParams extends MutableRecordStore({ name: '', invites: [] as string[] }) {
}

export class SetupProcess extends RecordStore({ progress: 0, done: false }) {

    constructor(private api: ApiClient, private boardId?: string, private trial?: string) {
        super();
    }

    public async go({ name, invites, surveyId }: SetupProps): Promise<string> {

        telemetry.emit('setup.initiated');
        const count = 4 + (!!this.boardId ? 1 : 0) + (!!this.trial ? 1 : 0);

        // Create account
        await waitFor(200);
        const account = await this.api.exec(v2.internal.setup.account(name, surveyId));
        this.updateState({ progress: 1 / count });
        let dest = `/${account.id}?redirect=${encodeURIComponent('/boards?action=setup')}`;

        // Swap refresh token
        await waitFor(200);
        await this.api.configure({ value: account.refreshToken });
        this.updateState({ progress: 2 / count });

        // Get workspaces
        await waitFor(200);
        const workspaces = await this.api.exec(v2.workspaces.list());
        this.updateState({ progress: 3 / count });

        // Process invites
        await waitFor(200);
        await this.api.exec(v2.admin.invites.send({
            emails: invites,
            type: 'member',
            workspaceIds: workspaces?.map(x => x.id) ?? [],
        }));
        this.updateState({ progress: 4 / count });

        // Process trial board
        if (this.trial) {
            await waitFor(200);
            await this.api.exec(v2.internal.setup.trial(this.trial));
        }

        // Process auto board
        if (this.boardId) {
            await waitFor(200);
            const resp = await this.api.exec(v2.boards.create({
                source: this.boardId,
                workspaceId: 'default',
            }));
            dest = `/${resp.id}?popup=welcome`;
        }

        // Wait a little bit more
        await waitFor(250);
        this.updateState({ done: true });

        telemetry.emit('setup.complete', { accountId: account.id, accountName: name });
        await waitFor(1000);

        return dest;
    }
}
